import React, { ReactChildren } from 'react';
import styled from 'styled-components';
import { theme } from '@style';
import { Dashboard } from '@components';

const Header = styled.div`
  color: ${theme.palette.black};
  font-size: ${theme.fontSizes.xxl};
  font-weight: ${theme.fontBold700};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled.div`
  display: flex;
  align-items: center;

  > h1 {
    color: ${props => props.theme.palette.headerText};
  }

  > svg {
    margin-right: 12px;
    color: ${props => props.theme.palette.headerText};
  }
`;

type Props = {
  title: string;
  children?: ReactChildren;
};

export const PageHeader = ({ title, children }: Props) => (
  <Header>
    <Title>
      {children}
      <h1>{title}</h1>
    </Title>
    <Dashboard />
  </Header>
);
